/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://m6h392odp2.execute-api.us-east-1.amazonaws.com/fast",
            "region": "us-east-1"
        },
        {
            "name": "fgnapi",
            "endpoint": "https://imrwgujxn6.execute-api.us-east-1.amazonaws.com/fast",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://2cgoemgmu5btjpriuqvodijx7q.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-5q5p4lwsmvfuhftrwzpz37lp7m",
    "aws_cognito_identity_pool_id": "us-east-1:0f26c953-b604-4fd1-b494-9d07d1113e39",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_lms8zSjOv",
    "aws_user_pools_web_client_id": "4qd0r2i7qq1i2p82kh1rpstt6t",
    "oauth": {
        "domain": "fgn6c984e36-6c984e36-fast.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/oauthlogin/,http://localhost:3000/oauthlogin/",
        "redirectSignOut": "http://localhost:3000/oauthlogout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "fgnstorage659b1-fast",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
